import React from 'react';

export default function CutsResultsHeader({
  selectedPrimal,
  searchTerm,
  favoritesOnly,
  setFavoritesOnly,
  isLoggedIn,
  leanOnly,
  setLeanOnly,
  resultCount,
  cookingMethods,
  cookingMethodFilter,
  setCookingMethodFilter,
  onClear
}) {
  const heading = selectedPrimal
    ? selectedPrimal.name
    : searchTerm.trim() || (favoritesOnly ? 'My Saved Cuts' : 'All Cuts');

  return (
    <section className="section cuts-results-header">
      <div className="container">
        <div className="cuts-results-header__toolbar">
          <div className="cuts-results-header__heading">
            <h2 className="cuts-results-header__title">{heading}</h2>
            <span className="cuts-results-header__count" aria-live="polite">
              {resultCount} Result{resultCount === 1 ? '' : 's'}
            </span>
          </div>
          <button type="button" className="cuts-results-header__clear" onClick={onClear}>
            Clear Filters
          </button>
          <div className="cuts-results-header__filters">
            <button
              type="button"
              className="cuts-results-header__pill"
              aria-pressed={favoritesOnly}
              onClick={() => {
                if (!isLoggedIn) {
                  window.location.href = '/login?redirect_to=' + encodeURIComponent(window.location.href);
                  return;
                }
                setFavoritesOnly((prev) => !prev);
              }}
            >
              Favorites
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 21S3 15 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 7-9 13-9 13Z" />
              </svg>
            </button>
            <button
              type="button"
              className="cuts-results-header__pill"
              aria-pressed={leanOnly}
              onClick={() => setLeanOnly((prev) => !prev)}
            >
              Lean Cuts
            </button>
            <div className="cuts-results-header__filter">
              <select
                value={cookingMethodFilter}
                onChange={(event) => setCookingMethodFilter(event.target.value)}
                aria-label="Filter by cooking method"
              >
                <option value="">Filter by cooking method</option>
                {cookingMethods.map((method) => (
                  <option key={method.id} value={method.id}>{method.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {selectedPrimal && selectedPrimal.description && (
          <p className="cuts-results-header__description">{selectedPrimal.description}</p>
        )}
        {selectedPrimal && selectedPrimal.butchers_note && (
          <div className="cuts-results-header__note">
            <strong>Butcher's Note:</strong> {selectedPrimal.butchers_note}
          </div>
        )}
      </div>
    </section>
  );
}
